

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Store from 'store';
import { Range, getTrackBackground } from 'react-range';
import {
    SpeakerHigh, SpeakerLow, SpeakerSlash,
} from '@phosphor-icons/react';
import exact from 'prop-types-exact';
import Button from '../../../common/button/Button';

class VolumeComponent extends Component {
    // eslint-disable-next-line react/sort-comp
    handleKeyDown = (event) => {
        this._volumeControls(event);
    }

    componentDidMount() {
        this.props.changeVolume(
            Number.parseInt(Store.get('volume'), 10) || this.props.volume,
        );

        if (!this.props.isMobile) {
            const handle = document.getElementsByClassName('react-range-handle')[0];

            handle?.setAttribute('tabindex', '-1');

            const slider = document.querySelector('.Volume .Slider');

            if (slider) {
                slider.addEventListener('keydown', this.handleKeyDown);
            }
        }
    }

    componentWillUnmount() {
        const slider = document.querySelector('.Volume .Slider');

        if (slider) {
            slider.removeEventListener('keydown', this.handleKeyDown);
        }
    }
    //    componentDidMount() {
    //        this.props.changeVolume(Number.parseInt(Store.get('volume'), 10) || this.props.volume);


    //        if (!this.props.isMobile) {
    //            document.getElementsByClassName('react-range-handle')[0].setAttribute('tabindex', '-1');

    // volume control via keys while focused
    //            document.querySelector('.Volume .Slider').addEventListener('keydown', (event) => {
    //                this._volumeControls(event);
    //            });
    //        }
    //    }

    //    componentWillUnmount() {
    //        document.querySelector('.Volume .Slider').removeEventListener('keydown', (event) => {
    //            this._volumeControls(event);
    //        });
    //    }


    _volumeControls = (e) => {
        // creates and verifies if 'up' key or 'down' key is being pressed
        const up = e.keyCode === 38;
        const down = e.keyCode === 40;

        // if none of them was pressed, return
        if (!up && !down) return;

        e.preventDefault();

        // volume that will be added/subtracted from total volume
        const volumeDiff = up ? 10 : -10;
        // defines the new volume
        let newVolume = this.props.volume + volumeDiff;

        if (newVolume > 90 && up) { // verifies if the new volume is higher than 90 and prevent it from getting higher than 100
            newVolume = 100;
        } else if (newVolume < 10 && down) { // verifies if the new volume is lower than 10 and prevent it from getting lower than 0
            newVolume = 0;
        }

        // go and change the volume on the store
        this.props.changeVolume(newVolume);
    }

    render() {
        if (this.props.isMobile) {
            return false;
        }

        const VolumeIcon = this.props.volume === 0 ? SpeakerSlash : (this.props.volume > 60 ? SpeakerHigh : SpeakerLow);
        const volume = [this.props.volume];

        return (
            <div className="Volume tw-h-full">
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
                <Button title="Mudo" onClick={this.props.toggleMuteVolume}>
                    <VolumeIcon size={20} color="white" className="icon" />
                    {' '}
                    <span className="visually-hidden visually-hidden-focusable">Mudo</span>
                </Button>
                <div className="Slider">
                    <Range
                        min={0}
                        max={100}
                        values={volume}
                        onChange={(values) => this.props.changeVolume(values[0])}
                        renderTrack={({ props, children }) => (
                            <div
                                onMouseDown={props.onMouseDown}
                                role="slider"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                aria-valuenow={this.props.volume}
                                tabIndex={-1}
                                style={{
                                    ...props.style,
                                    height: '30px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    ref={props.ref}
                                    style={{
                                        height: '5px',
                                        width: '100%',
                                        borderRadius: '10px',
                                        boxShadow: 'inset 0 1px 3px rgb(0 0 0 / 40%)',
                                        background: getTrackBackground({
                                            values: volume,
                                            colors: ['#0574FA', '#D0D5DD'],
                                            min: 0,
                                            max: 100,
                                        }),
                                    }}
                                >
                                    {children}
                                </div>
                            </div>
                        )}
                        renderThumb={({ props }) => (
                            <div
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...props}
                                className="react-range-handle"
                                style={{
                                    height: '10px',
                                    width: '10px',
                                    borderRadius: '30px',
                                    top: '50%',
                                    backgroundColor: '#fff',
                                    border: '1px solid #ccc',
                                    boxShadow: '0 1px 3px rgb(0 0 0 / 40%), 0 -1px 3px rgb(0 0 0 / 40%)',
                                }}
                            />
                        )}
                    />
                </div>
            </div>
        );
    }
}

VolumeComponent.propTypes = exact({
    volume: PropTypes.number.isRequired,
    changeVolume: PropTypes.func.isRequired,
    toggleMuteVolume: PropTypes.func.isRequired,
    isMobile: PropTypes.string,
});

export default VolumeComponent;
